import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import '../pages/Events.css';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

function fmtShort(start, end) {
  if (!start) return '';
  const s = new Date(start);
  const e = end ? new Date(end) : s;
  if (s.toDateString() === e.toDateString()) {
    return s.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  }
  return `${s.getDate()}–${e.getDate()} ${s.toLocaleDateString('en-IN', { month: 'short' })}`;
}

const EventBanner = () => {
  const [nearTerm, setNearTerm] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.getEvents()
      .then((events) => {
        if (!Array.isArray(events) || events.length === 0) return;
        const now = Date.now();
        // Soonest event starting within 30 days.
        const upcoming = events
          .filter((e) => {
            const start = new Date(e.start_date).getTime();
            return start - now > 0 && start - now <= THIRTY_DAYS_MS;
          })
          .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
        if (upcoming.length > 0) setNearTerm(upcoming[0]);
      })
      .catch(() => { /* swallow */ });
  }, []);

  if (!nearTerm || dismissed) return null;

  return (
    <div className="event-banner" role="region" aria-label="Upcoming event">
      <div className="container event-banner__inner">
        <div className="event-banner__text">
          <span className="event-banner__label">Upcoming</span>
          <strong>{nearTerm.title}</strong>
          {' · '}
          {fmtShort(nearTerm.start_date, nearTerm.end_date)}
          {nearTerm.venue ? ` · ${nearTerm.venue}` : ''}
        </div>
        <Link to={`/events/${nearTerm.slug}`} className="event-banner__cta">
          {nearTerm.pricing_mode === 'enquire' ? 'Enquire' : 'Register'}
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </Link>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          style={{
            background: 'transparent', border: 0, color: 'rgba(255,255,255,0.6)',
            fontSize: 18, cursor: 'pointer', padding: '0 4px', lineHeight: 1,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default EventBanner;
